import { writeFileSync } from 'fs';

export default (clientDirectory, pkg) => {
  writeFileSync(
    `/etc/systemd/system/${pkg.name}.service`,
    `
  [Unit]
  Description=${pkg.description}
  After=network.target
  [Service]
  Type=simple
  WorkingDirectory=${clientDirectory}
  ExecStart=${process.argv[0]} .
  Restart=always
  Environment=NODE_ENV=production
  SyslogIdentifier=${pkg.name}
  [Install]
  WantedBy=multi-user.target
  `.trim(),
  );
};
